export function gradeClass(g) {
  if (!g) return 'grade-c';
  const c = g.toUpperCase().charAt(0);
  return c === 'A' ? 'grade-a' : c === 'B' ? 'grade-b' : c === 'C' ? 'grade-c' : c === 'D' ? 'grade-d' : 'grade-f';
}
export function gradeColor(g) {
  if (!g) return 'color-c';
  const c = g.toUpperCase().charAt(0);
  return c === 'A' ? 'color-a' : c === 'B' ? 'color-b' : c === 'C' ? 'color-c' : c === 'D' ? 'color-d' : 'color-f';
}
export function bgColor(g) {
  if (!g) return 'bg-c';
  const c = g.toUpperCase().charAt(0);
  return c === 'A' ? 'bg-a' : c === 'B' ? 'bg-b' : c === 'C' ? 'bg-c' : c === 'D' ? 'bg-d' : 'bg-f';
}
export function gradeHex(g) {
  if (!g) return '#f59e0b';
  const c = g.toUpperCase().charAt(0);
  return c === 'A' ? '#10b981' : c === 'B' ? '#3b82f6' : c === 'C' ? '#f59e0b' : c === 'D' ? '#f97316' : '#ef4444';
}
export function pctGrade(pct) {
  return pct >= 90 ? 'A' : pct >= 80 ? 'B' : pct >= 70 ? 'C' : pct >= 60 ? 'D' : 'F';
}
